import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import '../../node_modules/ninjabootstrap/dist/js/bootstrap.bundle.min';
import { Fancybox } from "../../node_modules/@fancyapps/ui/dist/fancybox/fancybox.esm";
import owl from "../../node_modules/owl.carousel/dist/owl.carousel";
import AOS from "../../node_modules/aos/dist/aos";
import { smoothScroll } from "./components/smooth-scroll.js";
import noUiSlider from "../../node_modules/nouislider/dist/nouislider";

// Initialise our components on jQuery.ready…
jQuery(function ($) {
    //     ExampleComponent1.init();
    //     ExampleModule2.init();
    //     ReplaceObfuscatedEmailAddresses.init();
    //     AnimateOnPageLinks.init();

    //ANIMATE ON SCROLL
    AOS.init({
        duration: 1400
    });

    //FANCYBOX
    Fancybox.bind("[data-fancybox]", {
    });

    $(window).scroll(function(){
        if($(this).scrollTop()>0){
            $('#mainNav').addClass('scroll')
        } else{
            $('#mainNav').removeClass('scroll')
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
  var menu = document.getElementById('menuPrincipal');

  menu.addEventListener('shown.bs.collapse', function () {
    document.body.classList.add('no-scroll');
  });

  menu.addEventListener('hidden.bs.collapse', function () {
    document.body.classList.remove('no-scroll');
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const hash = window.location.hash;

  if (hash === '#geografia') {
    const tabButton = document.querySelector('[data-bs-target="#geografia"]');
    const tabContainer = document.querySelector('#DestinosInfo');
    const geografiaTabPane = document.querySelector('#geografia'); // O tab-pane da aba pai
    const firstInnerTabPane = document.querySelector('#v2-pills-tabContent .tab-pane'); // Primeiro filho

    if (tabButton && geografiaTabPane && tabContainer && firstInnerTabPane) {
      // Desativa tudo
      document.querySelectorAll('#pills-tab .nav-link').forEach(btn => btn.classList.remove('active'));
      document.querySelectorAll('.tab-pane').forEach(pane => pane.classList.remove('show', 'active'));

      // Ativa a tab pai "Geografia"
      tabButton.classList.add('active');
      geografiaTabPane.classList.add('show', 'active');

      // Ativa a primeira aba interna
      const innerTabBtn = document.querySelector('#v-pills-tab .nav-link');
      if (innerTabBtn) innerTabBtn.classList.add('active');

      firstInnerTabPane.classList.add('show', 'active');

      // Scroll até a seção
      setTimeout(() => {
        tabContainer.scrollIntoView({ behavior: 'smooth' });
      }, 200);
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const hash = window.location.hash;

  // Só continua se o hash for um destino válido
  if (hash.startsWith('#v-pills-')) {
    const outerTabButton = document.querySelector('[data-bs-target="#pills-home"]'); // tab pai
    const outerTabPane = document.querySelector('#pills-home'); // pane pai
    const innerTabButton = document.querySelector(`[data-bs-target="${hash}"]`); // botão lateral
    const innerTabPane = document.querySelector(hash); // conteúdo destino
    const container = document.querySelector('#DestinosInfo');

    if (outerTabButton && outerTabPane && innerTabButton && innerTabPane && container) {
      // 1. Remove classes active/show de todas as tabs
      document.querySelectorAll('#pills-tab .nav-link').forEach(btn => btn.classList.remove('active'));
      document.querySelectorAll('.tab-pane').forEach(pane => pane.classList.remove('show', 'active'));
      document.querySelectorAll('#v-pills-tab .nav-link').forEach(btn => btn.classList.remove('active'));

      // 2. Ativa aba principal "Rotas"
      outerTabButton.classList.add('active');
      outerTabPane.classList.add('show', 'active');

      // 3. Ativa botão lateral e conteúdo correto
      innerTabButton.classList.add('active');
      innerTabPane.classList.add('show', 'active');

      // 4. Scroll suave até a seção
      setTimeout(() => {
        const offset = 120; // ajuste se tiver header fixo
        const top = container.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }, 200);
    }
  }
});

(function () {
  document.addEventListener('DOMContentLoaded', function () {
  if (typeof MAPA_DATA !== 'object' || !document.querySelector('.mapa-geografia-wrapper')) {
    return;
  }

    const wrapper = document.querySelector('.mapa-geografia-wrapper');
    if (!wrapper) return;

    const svgEl = wrapper.querySelector('svg');
    if (!svgEl) {
      console.warn('SVG do mapa não encontrado dentro de .mapa-geografia-wrapper');
      return;
    }

    const mapaData = MAPA_DATA;
    const tooltips = {};
    const cameraNodes = {};

    // Criar tooltip
    function createTooltipForCity(cityId, imgs) {
      const t = document.createElement('div');
      t.className = 'map-tooltip';
      t.setAttribute('data-map-city', cityId);
      t.setAttribute('aria-hidden', 'true');

      const inner = document.createElement('div');
      inner.className = 'map-tooltip__inner';

      if (imgs && imgs.length > 0) {
        const positions = ['p-left', 'p-center', 'p-right'];
        imgs.slice(0, 3).forEach((src, i) => {
          const frame = document.createElement('div');
          frame.className = `polaroid ${positions[i]}`;
          const img = document.createElement('img');
          img.src = src;
          img.alt = '';
          frame.appendChild(img);
          inner.appendChild(frame);
        });
      }

      // Label sempre aparece
      const label = document.createElement('div');
      label.className = 'city-label';
      label.innerText = cityId
        .replace(/_/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
      inner.appendChild(label);

      t.appendChild(inner);
      wrapper.appendChild(t);
      return t;
    }

    // Criar ícone câmera somente se houver imagens
    function createCameraElement(cityId) {
      const cameraSVG =
        '<svg class="map-camera" width="22" height="20" viewBox="0 0 11 10" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0.5H4L3 2H1C0.72386 2 0.5 2.22386 0.5 2.5V9C0.5 9.27615 0.72386 9.5 1 9.5H10C10.2761 9.5 10.5 9.27615 10.5 9V2.5C10.5 2.22386 10.2761 2 10 2H8L7 0.5ZM5.5 7.5C6.60457 7.5 7.5 6.60457 7.5 5.5C7.5 4.39543 6.60457 3.5 5.5 3.5C4.39543 3.5 3.5 4.39543 3.5 5.5C3.5 6.60457 4.39543 7.5 5.5 7.5Z" fill="#F7F7F5"/></svg>';

      const wrapperG = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      wrapperG.setAttribute('class', 'map-camera-wrapper');
      wrapperG.setAttribute('data-map-camera-for', cityId);

      const foreign = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
      foreign.setAttribute('width', 22);
      foreign.setAttribute('height', 20);
      foreign.innerHTML = cameraSVG;

      wrapperG.appendChild(foreign);
      svgEl.appendChild(wrapperG);
      return wrapperG;
    }

    // Posicionar tooltip
    function positionTooltipForPath(pathEl, tooltipEl) {
      if (!pathEl || !tooltipEl) return;
      const pathRect = pathEl.getBoundingClientRect();
      const wrapperRect = wrapper.getBoundingClientRect();

      const centerX = pathRect.left + pathRect.width / 2;
      const tooltipWidth = tooltipEl.offsetWidth;
      const tooltipHeight = tooltipEl.offsetHeight;
      const offset = 12;

      let left = centerX - tooltipWidth / 2 - wrapperRect.left;
      let top = pathRect.top - wrapperRect.top - tooltipHeight - offset;

      if (top < 0) {
        top = pathRect.bottom - wrapperRect.top + offset;
      }
      if (left < 0) left = 4;
      if (left + tooltipWidth > wrapperRect.width) {
        left = wrapperRect.width - tooltipWidth - 4;
      }

      tooltipEl.style.left = `${left}px`;
      tooltipEl.style.top = `${top}px`;
    }

    // Posicionar câmera
    function positionCameraForPath(pathEl, cameraG) {
      if (!pathEl || !cameraG) return;
      const bbox = pathEl.getBBox();
      const cx = bbox.x + bbox.width / 2;
      const cy = bbox.y + bbox.height / 2;
      cameraG.setAttribute('transform', `translate(${cx - 11}, ${cy - 10})`);
    }

    // Loop cidades
    Object.keys(mapaData).forEach((cityId) => {
      const entry = mapaData[cityId];
      const pathEl = svgEl.querySelector(`#${CSS.escape(cityId)}`);
      if (!pathEl) return;

      // cor
      if (entry.cor) pathEl.style.fill = entry.cor;

      // cursor pointer
      pathEl.style.cursor = 'pointer';

      // só cria câmera se houver imagens
      if (entry.imgs && entry.imgs.length > 0) {
        const cam = createCameraElement(cityId);
        cameraNodes[cityId] = cam;
      }

      // tooltip (sempre tem label)
      const tooltip = createTooltipForCity(cityId, entry.imgs || []);
      tooltips[cityId] = tooltip;

      // eventos
      function show() {
        tooltip.setAttribute('aria-hidden', 'false');
        tooltip.classList.add('map-tooltip--visible');
        positionTooltipForPath(pathEl, tooltip);
      }
      function hide() {
        tooltip.setAttribute('aria-hidden', 'true');
        tooltip.classList.remove('map-tooltip--visible');
      }

      pathEl.addEventListener('mouseenter', show);
      pathEl.addEventListener('mouseleave', hide);
      pathEl.addEventListener('focus', show);
      pathEl.addEventListener('blur', hide);
      // evita qualquer comportamento em click
      pathEl.addEventListener('click', e => e.preventDefault());
    });

    function repositionAll() {
      Object.keys(mapaData).forEach((cityId) => {
        const pathEl = svgEl.querySelector(`#${CSS.escape(cityId)}`);
        const cam = cameraNodes[cityId];
        if (pathEl && cam) positionCameraForPath(pathEl, cam);
      });
    }
    window.addEventListener('resize', () => repositionAll());
    setTimeout(repositionAll, 100);
  });
})();
